let auth0Client = null;

export function configureAuth0Client(client) {
  auth0Client = client;
}

export function getConfiguredAuth0Client() {
  return auth0Client;
}
